import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e79f7b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "backdrop z-10"
}
const _hoisted_2 = { class: "flex items-center justify-center text-white text-btn" }
const _hoisted_3 = {
  key: 0,
  class: "text-center"
}
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = {
  key: 1,
  class: "text-center"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons-round align-middle text-lg leading-none" }, "arrow_back", -1))
const _hoisted_7 = { class: "pl-2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons-round align-middle text-lg leading-none" }, "undo", -1))
const _hoisted_9 = { class: "pl-2" }
const _hoisted_10 = {
  key: 2,
  class: "text-center mx-8"
}
const _hoisted_11 = { class: "mb-4" }
const _hoisted_12 = {
  key: 3,
  class: "text-center mx-8"
}
const _hoisted_13 = { class: "mb-4" }
const _hoisted_14 = {
  key: 4,
  class: "text-center mx-8"
}
const _hoisted_15 = { class: "mb-4" }
const _hoisted_16 = {
  key: 0,
  class: "backdrop flex flex-col justify-center items-center z-20",
  style: {"font-size":"16px"}
}
const _hoisted_17 = { class: "pl-2" }
const _hoisted_18 = { class: "pl-2" }
const _hoisted_19 = { class: "pl-2" }
const _hoisted_20 = { class: "pl-2" }
const _hoisted_21 = { class: "pl-2" }
const _hoisted_22 = { class: "pl-2" }
const _hoisted_23 = {
  class: "z-10 md:rounded-lg md:overflow-hidden relative flex md:absolute md:inset-0 w-screen md:w-auto",
  ref: "renderContainer"
}
const _hoisted_24 = {
  class: "render-content relative mx-auto",
  ref: "renderContent"
}
const _hoisted_25 = {
  class: "konva-overlay-container pointer-events-none",
  ref: "konvaOverlayContainer"
}
const _hoisted_26 = {
  key: 0,
  class: "absolute right-5 top-7 hidden md:block"
}
const _hoisted_27 = { class: "render-controls flex flex-col items-end" }
const _hoisted_28 = { class: "font-semibold flex-1 pl-5 whitespace-nowrap" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center items-center pl-3 mr-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "material-icons-round text-3xl" }, "edit")
], -1))
const _hoisted_30 = { class: "font-semibold flex-1 pl-5 whitespace-nowrap" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center items-center pl-3 mr-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "material-icons-round text-3xl" }, "gradient")
], -1))
const _hoisted_32 = { class: "font-semibold flex-1 pl-5 whitespace-nowrap" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center items-center pl-3 mr-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "material-icons-round text-3xl" }, "draw")
], -1))
const _hoisted_34 = { class: "font-semibold flex-1 pl-5 whitespace-nowrap" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center items-center pl-3 mr-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "material-icons-round text-3xl" }, "open_with")
], -1))
const _hoisted_36 = { class: "font-semibold flex-1 pl-5 whitespace-nowrap" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center items-center pl-3 mr-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "material-icons-round text-3xl" }, "autorenew")
], -1))
const _hoisted_38 = { class: "font-semibold flex-1 pl-5 whitespace-nowrap" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center items-center pl-3 mr-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "material-icons-round text-3xl" }, "zoom_in")
], -1))
const _hoisted_40 = {
  key: 0,
  class: "absolute right-5 top-7 block md:hidden z-20"
}
const _hoisted_41 = { class: "render-controls flex flex-col items-end" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons-round text-3xl" }, "edit", -1))
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = {
  ref: "loader",
  style: {"background":"#ffffff","z-index":"999"},
  class: "w-screen md:w-full h-full absolute flex items-center justify-center"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader relative" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div")
], -1))
const _hoisted_46 = [
  _hoisted_45
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Camera = _resolveComponent("Camera")!
  const _component_Plane = _resolveComponent("Plane")!
  const _component_Scene = _resolveComponent("Scene")!
  const _component_Renderer = _resolveComponent("Renderer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (!_ctx.isNoneMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", {
                class: "grid md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 md:h-full fixed md:static inset-0",
                style: _normalizeStyle({ top: (55 + _ctx.renderHeight) + 'px' })
              }, [
                _createElementVNode("div", _hoisted_2, [
                  (_ctx.isAdjustMode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("Z miško se postavite na izrisano dvorišče. Držite klik in drsite po dvorišču (z drsenjem prilagajate vse možnosti).")), 1),
                        _createElementVNode("button", {
                          type: "button",
                          class: "app-button-finish text-white text-btn",
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.disableAdjustMode && _ctx.disableAdjustMode(...args)))
                        }, _toDisplayString(_ctx.$t("Potrdi naklon")), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isDrawMode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("a", {
                          class: "block mb-5 text-white",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.removeLastShapePoint && _ctx.removeLastShapePoint(...args)))
                        }, [
                          _hoisted_6,
                          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("Razveljavi")), 1)
                        ]),
                        _createElementVNode("a", {
                          class: "block mb-5 text-white",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.removeAllShapePoints && _ctx.removeAllShapePoints(...args)))
                        }, [
                          _hoisted_8,
                          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("Začni znova")), 1)
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "app-button-finish",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.disableDrawModeAndCreateMeshes(); _ctx.incrementMeshCreatedCounter();})
                        }, _toDisplayString(_ctx.$t("Končaj izris")), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isTextureMoveMode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("Z miško se postavite na izrisano dvorišče. Držite klik in drsite po dvorišču (z drsenjem prilagajate vse možnosti).")), 1),
                        _createElementVNode("button", {
                          type: "button",
                          class: "app-button-finish",
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.disableTextureMoveMode && _ctx.disableTextureMoveMode(...args)))
                        }, _toDisplayString(_ctx.$t("Potrdi premik")), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isTextureRotateMode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("Z miško se postavite na izrisano dvorišče. Držite klik in drsite po dvorišču (z drsenjem prilagajate vse možnosti).")), 1),
                        _createElementVNode("button", {
                          type: "button",
                          class: "app-button-finish",
                          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.disableTextureRotateMode && _ctx.disableTextureRotateMode(...args)))
                        }, _toDisplayString(_ctx.$t("Potrdi rotacijo")), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isTextureZoomMode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t("Z miško se postavite na izrisano dvorišče. Držite klik in drsite po dvorišču (z drsenjem prilagajate vse možnosti).")), 1),
                        _createElementVNode("button", {
                          type: "button",
                          class: "app-button-primary",
                          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.disableTextureZoomMode && _ctx.disableTextureZoomMode(...args)))
                        }, _toDisplayString(_ctx.$t("Potrdi")), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 4)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.showMobileControlsOverlay)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("a", {
                class: "block mb-5 text-white",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.changeImage && _ctx.changeImage(...args)))
              }, [
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t("Izberi novo fotografijo")), 1)
              ]),
              (_ctx.showButtons)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "block mb-5 text-white",
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.enableAdjustMode && _ctx.enableAdjustMode(...args)))
                  }, [
                    _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("Spremeni naklon")), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showButtons)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    class: "block mb-5 text-white",
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.enableDrawMode && _ctx.enableDrawMode(...args)))
                  }, [
                    _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("Ponovno nariši robove")), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("a", {
                class: "block mb-5 text-white",
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.enableTextureMoveMode && _ctx.enableTextureMoveMode(...args)))
              }, [
                _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t("Premakni tlakovce")), 1)
              ]),
              _createElementVNode("a", {
                class: "block mb-5 text-white",
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.enableTextureRotateMode && _ctx.enableTextureRotateMode(...args)))
              }, [
                _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t("Rotiraj tlakovce")), 1)
              ]),
              _createElementVNode("a", {
                class: "block mb-5 text-white",
                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.enableTextureZoomMode && _ctx.enableTextureZoomMode(...args)))
              }, [
                _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("Povečaj / zmanjšaj tlakovce")), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", {
          class: _normalizeClass(["render absolute inset-0 flex overflow-hidden md:rounded-lg", { 'cursor-crosshair': _ctx.isDrawMode, 'cursor-grab': _ctx.isTextureMoveMode || _ctx.isTextureRotateMode || _ctx.isTextureZoomMode }]),
          ref: "canvasContainerElement"
        }, [
          _createVNode(_component_Renderer, {
            ref: "renderer",
            resize: "",
            antialias: "",
            "orbit-ctrl": true,
            pointer: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Camera, {
                ref: "camera",
                position: { x: _ctx.cameraX, y: _ctx.cameraY, z: _ctx.cameraZ }
              }, null, 8, ["position"]),
              _createVNode(_component_Scene, {
                ref: "scene",
                background: "#a0a0a0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Plane, {
                    ref: "backgroundPlane",
                    width: _ctx.backgroundPlaneWidth,
                    height: _ctx.backgroundPlaneHeight
                  }, null, 8, ["width", "height"]),
                  _createVNode(_component_Plane, {
                    ref: "intersectionPlane",
                    width: _ctx.intersectionPlaneWidth,
                    height: _ctx.intersectionPlaneHeight,
                    rotation: _ctx.intersectionPlaneRotation
                  }, null, 8, ["width", "height", "rotation"])
                ]),
                _: 1
              }, 512)
            ]),
            _: 1
          }, 512),
          _createElementVNode("div", _hoisted_25, null, 512)
        ], 2),
        _createVNode(_Transition, { name: "fade-slide-right" }, {
          default: _withCtx(() => [
            (_ctx.isNoneMode)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", {
                      class: "control-button bg-white h-12 w-12 hover:w-60 flex justify-end items-center rounded-full mb-3 overflow-hidden transition-all cursor-pointer",
                      onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.changeImage && _ctx.changeImage(...args)))
                    }, [
                      _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t("Izberi novo fotografijo")), 1),
                      _hoisted_29
                    ]),
                    (_ctx.showButtons)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "control-button bg-white h-12 w-12 hover:w-60 flex justify-end items-center rounded-full mb-3 overflow-hidden transition-all cursor-pointer",
                          onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.enableAdjustMode && _ctx.enableAdjustMode(...args)))
                        }, [
                          _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$t("Spremeni naklon")), 1),
                          _hoisted_31
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.showButtons)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "control-button bg-white h-12 w-12 hover:w-60 flex justify-end items-center rounded-full mb-3 overflow-hidden transition-all cursor-pointer",
                          onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.enableDrawMode && _ctx.enableDrawMode(...args)))
                        }, [
                          _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t("Ponovno nariši robove")), 1),
                          _hoisted_33
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: "control-button bg-white h-12 w-12 hover:w-60 flex justify-end items-center rounded-full mb-3 overflow-hidden transition-all cursor-pointer",
                      onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.enableTextureMoveMode && _ctx.enableTextureMoveMode(...args)))
                    }, [
                      _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.$t("Premakni tlakovce")), 1),
                      _hoisted_35
                    ]),
                    _createElementVNode("div", {
                      class: "control-button bg-white h-12 w-12 hover:w-60 flex justify-end items-center rounded-full mb-3 overflow-hidden transition-all cursor-pointer",
                      onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.enableTextureRotateMode && _ctx.enableTextureRotateMode(...args)))
                    }, [
                      _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.$t("Rotiraj tlakovce")), 1),
                      _hoisted_37
                    ]),
                    _createElementVNode("div", {
                      class: "control-button bg-white h-12 w-12 hover:w-60 flex justify-end items-center rounded-full mb-3 overflow-hidden transition-all cursor-pointer",
                      onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.enableTextureZoomMode && _ctx.enableTextureZoomMode(...args)))
                    }, [
                      _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.$t("Povečaj / zmanjšaj tlakovce")), 1),
                      _hoisted_39
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ], 512)
    ], 512),
    _createVNode(_Transition, { name: "fade-slide-right" }, {
      default: _withCtx(() => [
        (_ctx.isNoneMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", {
                  class: "control-button bg-white h-12 w-12 flex justify-center items-center rounded-full cursor-pointer",
                  onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.toggleMobileControlsOverlay && _ctx.toggleMobileControlsOverlay(...args)))
                }, _hoisted_43)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_44, _hoisted_46, 512)
  ], 64))
}